import axios from 'axios';

const API_BASE_URL = '/api/analytics-reports';

class AnalyticsReportService {
  /**
   * Gera e baixa PDF do relatório analítico
   * @param {string} selectedYear - Ano selecionado para filtrar
   * @returns {Promise<Object>}
   */
  static async generatePDF(selectedYear = 'Todos os Anos') {
    try {
      const response = await axios.post(`${API_BASE_URL}/pdf`, {
        selectedYear
      }, {
        responseType: 'arraybuffer',
        timeout: 180000, // 3 minutos
        withCredentials: true, // ✅ Enviar cookies automaticamente
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Verificar se a resposta é válida
      if (!response.data || response.data.byteLength === 0) {
        throw new Error('PDF vazio ou inválido recebido do servidor');
      }

      // Criar blob do PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      
      // Extrair nome do arquivo do header
      let fileName = `relatorio_analitico_${selectedYear !== 'Todos os Anos' ? selectedYear : 'completo'}_${new Date().toISOString().split('T')[0]}.pdf`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch) {
          fileName = fileNameMatch[1];
        }
      }

      // Criar URL temporária para download
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      
      // Simular clique para download
      document.body.appendChild(link);
      link.click();
      
      // Limpeza
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        fileName,
        message: 'Relatório Analítico gerado e baixado com sucesso'
      };

    } catch (error) {
      let errorMessage = 'Erro ao gerar relatório analítico';
      
      if (error.response && error.response.status === 404) {
        errorMessage = 'Nenhuma parceria encontrada para gerar o relatório';
      } else if (error.response && error.response.data) {
        try {
          let errorData = error.response.data;
          if (errorData instanceof ArrayBuffer) {
            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(errorData);
            errorData = JSON.parse(text);
          }
          if (errorData && errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (parseError) {
          // Ignora erro de parse
        }
      } else if (error.request) {
        errorMessage = 'Erro de conexão. Verifique sua internet e tente novamente.';
      } else if (error.code === 'ECONNABORTED') {
        errorMessage = 'Timeout: O relatório está demorando muito para ser gerado.';
      }

      throw new Error(errorMessage);
    }
  }
}

export default AnalyticsReportService;
